import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import '../css/round-checkbox.scss';

export class RoundCheckbox extends Component {
    static propTypes = {
        checked: PropTypes.bool,
        active: PropTypes.bool,
        hidden: PropTypes.bool,
        size: PropTypes.number,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        checked: false,
        hidden: false,
        size: 24,
    };

    render() {
        const {checked, active, hidden, onChange, size, ...rest} = this.props;

        const circleStyle = {
            display: checked ? 'block' : 'none'
        };

        return (
            <div
                className={classNames('round', {checked, active})}
                style={{
                    visibility: checked || !hidden ? 'visible' : 'hidden',
                    background: 'none',
                    float: 'left',
                    width: size,
                    height: size,
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    pointerEvents: 'visible'
                }}
                onClick={onChange}
                {...rest}
            >
                <svg
                    height="100%"
                    viewBox="0 0 24 24"
                    width="100%"
                    xmlns="http://www.w3.org/2000/svg">

                    <radialGradient
                        id="shadow"
                        cx="38"
                        cy="95.488"
                        r="10.488"
                        gradientTransform="matrix(1 0 0 -1 -26 109)"
                        gradientUnits="userSpaceOnUse">
                        <stop
                            offset=".832"
                            stopColor="#010101"/>
                        <stop
                            offset="1"
                            stopColor="#010101"
                            stopOpacity="0"/>
                    </radialGradient>

                    <circle
                        style={circleStyle}
                        opacity=".26"
                        fill="url(#shadow)"
                        cx="12" cy="13.512"
                        r="10.488"/>
                    <circle
                        style={circleStyle}
                        fill="#FFF"
                        cx="12"
                        cy="12.2"
                        r="8.292"/>
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RoundCheckbox.js